let config = {
  inputLabel: 'clickthroughUrl',
  key: 'ctaurl',
  inputType: 'textfield',
};

export default config;
